import actionTypes from "../webActionTypes";

// checkMemberLogin: 'checkMemberLogin',
// beginCheckMemberLogin: 'beginCheckMemberLogin',
// recvCheckMemberLoginResult: 'recvCheckMemberLoginResult',
// recvCheckMemberLoginError: 'recvCheckMemberLoginError',
// setLoginInfo: 'setLoginInfo',

// showLoginError: 'showLoginError',
// hideLoginError: 'hideLoginError',

// logout: 'logout',
// logoutDone: 'logoutDone',

const reducers = {
    [actionTypes.beginCheckAdminLogin]: function(state, action) {
        if (state.isCheckingLogin) return state;

        return Object.assign({}, state, {
            isCheckingLogin: true
        });
    },

    [actionTypes.setAdminLoginInfo]: function(state, action) {
        if (state.loginInfo === action.payload.result) return state;

        return Object.assign({}, state, {
            isLogin: true,
            isCheckingLogin: false,
            loginInfo: action.payload.admininfo
        });
    },

    [actionTypes.beginAdminLogout]: function(state, action) {
        return Object.assign({}, state, {
            isLogouting: true,
        });
    },

    [actionTypes.logoutDone]: function(state, action) {
        return Object.assign({}, state, {
            isLogin: false,
            loginInfo: {},
            isLogouting: false,
        });
    },

    [actionTypes.showLoginError]: function(state, action) {
        if (state.isLoginError) return state;

        return Object.assign({}, state, {
            isLoginError: true
        });
    },

    [actionTypes.hideLoginError]: function(state, action) {
        if (!state.isLoginError) return state;

        return Object.assign({}, state, {
            isLoginError: false
        });
    }
};

export default function createReducers(initialState) {
    return function reducer(state = initialState, action) {
        if (reducers.hasOwnProperty(action.type)) {
            return reducers[action.type](state, action);
        } else {
            return state;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/reducers/adminReducers.js